import React, { useEffect, useState } from "react"
import styles from "./FiringInfo.module.css"
import { axiosInstance } from "../../../Helpers/axiosInstance"
import {faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import hy from 'date-fns/locale/hy';
import { format, formatDate } from 'date-fns';
import FiringParts from "../../../Modals/Firing/FiringParts";

                 
const FiringInfo = ({base, unit, added, baseList, changeSelectedBase,closeModal, setAdded }) => { 
    const [firingInfo, setFiringInfo] = useState(null)
    const [isOpenModal, setIsOpenModal] = useState(false)
    const [idx, setIdx] = useState(null)

    const fetchFiringInfo = async () => {
            try {
                const response = await axiosInstance.get(`/admin/firing/${base.base_number}`)
                if(!response.data.status) {
                    console.error("Failed to fetch firing info")
                    return
                }
                
                setFiringInfo(response.data.data)
            } catch (error) {
                console.error("Error fetching firing info:", error)
            }
        }

    useEffect(() => {
        fetchFiringInfo()
    }, [base.base_number])

       useEffect(() => {
        if(added){
            fetchFiringInfo()
        }
    }, [added])

    const getDate = (date) => {
        if (!date) return
        const dateNum = new Date(+date)
        const formatedDate = `${dateNum.getHours() > 9 ? dateNum.getHours() : "0" + dateNum.getHours()}:${dateNum.getMinutes() > 9 ? dateNum.getMinutes() : "0" + dateNum.getMinutes()} ${dateNum.getDate() > 9 ? dateNum.getDate() : "0" + dateNum.getDate()}/${dateNum.getMonth() > 8 ? dateNum.getMonth() + 1 : "0" + (dateNum.getMonth() + 1)}/${dateNum.getFullYear()}`
        return formatedDate
    }
    const deleteFiringInfo = async(id) => {
        try{
                const response = await axiosInstance.delete(`/admin/firing/${base.base_number}/${id}`)
                if(!response.data.status) {
                        console.error("Failed to delete firing info")
                        return
                    }
                    setFiringInfo(response.data.data)
         
        }catch(error){
            console.log('error', error)
        }
    }

    return (
        <div className={styles['firing-info']} onClick={(e) => e.stopPropagation()}>
           { firingInfo && firingInfo.fired.sort((a,b) => a.date > b.date ? -1 : 1).map((item, index) => {
               return (
                   <table key={index}>
                          <thead>
                            <tr>
                                <th>{getDate(item.date)}</th>
                                <th>Հակառակորդի կողմից</th>
                                <th>Պատասխան կրակ</th>
                                <th className={styles['managment-btns']}>
                                    <FontAwesomeIcon icon={faPenToSquare} className={styles["edit"]} title="Խմբագրել" onClick={() =>{setIdx(index); setIsOpenModal(true)}} />
                                    <FontAwesomeIcon icon={faTrash} className={styles["remove"]} title="Ջնջել հենակետը" onClick={() => {deleteFiringInfo(item._id)}}/>
                                </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                            <td>
                            </td>
                          <td className={styles['table-info']}>
                                {item.us.fire > 0 ?<p>Հրդեհ - {item.us.fire}</p> : ''}
                                {item.us.mina > 0 ?<p>Ական - {item.us.mina}</p> : ''}
                                {item.us.signal > 0 ?<p>Ազդանշանային - {item.us.signal}</p> : ''}
                                {item.us.weapon.map((weapon, idx) => (
                            <p key={idx}>{weapon.weapon_type} - {weapon.firing_count} կրակոց, {weapon.bullet_count} փամփուշտ</p>
                        ))}
                          </td>
                          <td className={styles['table-info']}>
                                {item.we.fire > 0 ?<p>Հրդեհ - {item.we.fire}</p> : ''}
                                {item.we.mina > 0 ?<p>Ական - {item.we.mina}</p> : ''}
                                {item.we.signal > 0 ?<p>Ազդանշանային - {item.we.signal}</p> : ''}
                                {item.we.weapon.map((weapon, idx) => (
                            <p key={idx}>{weapon.weapon_type} - {weapon.firing_count} կրակոց, {weapon.bullet_count} փամփուշտ</p>
                        ))} 
                          </td>
                         
                          </tr>
                            

                          </tbody>
                       
                        </table>

               )
           })}

        {isOpenModal && <FiringParts baseList={baseList} fetchFiringInfo={fetchFiringInfo} firingIndex={idx} firingInfo={firingInfo} base={base} currentUnit={unit} closeModal={() => {closeModal(); setIsOpenModal(false)}} setAdded={setAdded} changeSelectedBase={changeSelectedBase} />}
        </div>
    )
}


export default FiringInfo